/* eslint-disable max-len */
import React from 'react'

const green = '#00b550'

function Checkmark(): JSX.Element {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 10 20C4.48 20 0 15.52 0 10ZM4.16668 9.99999L8.33335 14.1667L15.8333 6.66666L14.6583 5.48333L8.33335 11.8083L5.34168 8.82499L4.16668 9.99999Z"
        fill={ green }
      />
    </svg>

  )
}

export default Checkmark
